import { useSelector } from "react-redux";
import AuthenticationClient from "@common/api/AuthenticationClient";

const useOrganisationTree = () => {
  const operators = useSelector((state) =>
    state.operators.filter((x) => x.value !== -1),
  );

  const { complianceAuthorisationUseCompany } = useSelector(
    (state) => state.logIn,
  );

  const switchTenant = (tenant) => {
    if (operators.length < 2) {
      return;
    }
    AuthenticationClient.SwitchTenant(tenant).then(({ status, accessToken }) =>
      {
        if (status !== 200 && status !== 400) return;

        if (status === 200) sessionStorage.setItem("accessToken", accessToken); 
      }
    );
  };

  const onCompanyChange = (company) => {
    if (!company.id || !complianceAuthorisationUseCompany) {
      return;
    }

    switchTenant(company.id);
  };

  const onOrgTreeSelectionChange = (operator, company) => {
    if (complianceAuthorisationUseCompany) {
      return onCompanyChange(company);
    }

    if (!operator) {
      return;
    }

    switchTenant(operator);
  };

  return { switchTenant, onCompanyChange, onOrgTreeSelectionChange };
};

export default useOrganisationTree;
